import * as React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'

import MeAnonymousLabel from 'modules/surveys/components/Participants/common/MeAnonymousLabel'
import type { IQuestionGroupActor } from 'modules/surveys/store/models/QuestionGroup'

function PlaceholderLabel() {
  return (
    <Box>
      <Box flexDirection="row" gap="s16" alignItems="center">
        <Avatar label={i18n.t('common.anonymous_user')} />
        <Text.Normal>{i18n.t('common.anonymous_user')}</Text.Normal>
      </Box>
    </Box>
  )
}

interface UserProps {
  respondent: IQuestionGroupActor
  description?: string | null | undefined
}

function UserLabel({ respondent, description }: UserProps) {
  return (
    <>
      <UserAvatar
        user={{ avatar: respondent.avatar ?? undefined, fullName: respondent.full_name ?? '' }}
        size="s40"
      />
      <Box justifyContent="center">
        <Text.Normal size="300" weight="medium">
          {respondent.full_name ?? ''}
        </Text.Normal>
        {description && (
          <Text.Normal size="200" color="grey800">
            {description}
          </Text.Normal>
        )}
      </Box>
    </>
  )
}

interface Props {
  description?: string | null | undefined
  respondent?: IQuestionGroupActor | null | undefined
  isAnonymous?: boolean
}

const UserBlock = ({
  children,
  description,
  respondent,
  isAnonymous,
}: React.PropsWithChildren<Props>) => (
  <Box
    overflowY="hidden"
    overflowX="hidden"
    borderRadius={{
      all: 'abs008',
    }}
    border={{
      all: {
        style: 'solid',
        width: 's1',
        color: 'grey400',
      },
    }}
  >
    <Box
      background="grey000White"
      flexDirection="row"
      paddingX="s16"
      paddingY="s24"
      gap="s16"
      border={{
        bottom: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
    >
      {respondent &&
        (isAnonymous ? (
          <MeAnonymousLabel respondent={respondent} />
        ) : (
          <UserLabel respondent={respondent} description={description} />
        ))}
      {!respondent && <PlaceholderLabel />}
    </Box>
    <Box
      background="grey100"
      borderRadius={{
        bottomRight: 'abs008',
        bottomLeft: 'abs008',
      }}
    >
      {children}
    </Box>
  </Box>
)

export default UserBlock
